<template>
  <div :is-chat-online="isChatOnline">
    <Header :is-chat-online="isChatOnline" />
    <!-- <Debug /> -->
    <OffsetNav />
    <div id="offer-top"></div>
    <slot></slot>
    <Footer />
    <a 
      id="go-top"
      href="#" 
      @click="scrollToTop"
      :class="'can-scroll'"
    >
      <i class="material-icons">expand_less</i>
    </a>
    <img 
      id="chatPixel" 
      :src="chatPixelSrc" 
      @load="checkChatStatus($event)" 
      style="display: none;"
    />
  </div>
</template>

<script>

import Header from '../components/layout/Header.vue';
import Footer from '../components/layout/Footer.vue';
import OffsetNav from '../components/layout/OffsetNav.vue';
import Debug from '../components/layout/Debug.vue';

export default {
  components: {
    Header,
    Footer,
    OffsetNav,
    Debug,
  },
  data() {
    return {
      isAdmin: false,
      canScroll: false,
      isChatOnline: false,
    }
  },
  computed: {
    chatPixelSrc() {
      return 'https://image.providesupport.com/online-presence-image/0af9vnyn0kchv09maiwenbeceg?t=' + (new Date()).getTime();
    }
  },
  mounted: function () {
    this.isAdmin = this.$router.currentRoute.path.split('/')
      .indexOf('admin') !== -1;
  },
  
  methods: {
    navClick: function(name) {
      this.$router.app.$emit(name);
    },
    scrollToTop: function(e) {
      e.preventDefault();
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      })
      return false;
    },
    checkChatStatus: function(evt) {
      this.isChatOnline = (event.target.width === 2);
    }
  }
}
</script>